import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { ReactNode, useEffect } from 'react';
import { LazyImage } from '@ui/common/lazy-image.tsx';
import callIcon from './assets/call_icon.svg';
import mailIcon from './assets/mail_icon.svg';
import whatsappIcon from './assets/whatsapp_icon.svg';
import instagramIcon from './assets/instagram_icon.svg';
import { BreadcrumbItem, Breadcrumbs } from '@heroui/react';
import { Home2 } from 'iconsax-react';

const Item = ({
  title,
  subtitle,
  onPress,
  icon,
}: {
  title: string;
  subtitle: string;
  icon: ReactNode;
  onPress: () => void;
}) => {
  return (
    <button
      className="flex flex-row items-center gap-x-4 bg-[#F8F9FA] p-4 rounded-xl"
      onClick={onPress}
    >
      <div className="flex items-center justify-between bg-[#FFFFFF] h-9 w-9 rounded-lg p-2">
        {icon}
      </div>
      <div className="flex flex-col items-start gap-y-2">
        <p className="font-medium text-[#222222] text-xs">{title}</p>
        <p className="text-[#60656C] text-sm">{subtitle}</p>
      </div>
    </button>
  );
};

export const ContactsPage = () => {
  const set = useNavbar();

  useEffect(() => {
    set.contacts();
  }, []);

  return (
    <div className="container max-w-7xl lg:mx-auto">
      <div className="hidden lg:block mt-12">
        <Breadcrumbs>
          <BreadcrumbItem href="/">
            <Home2 size="24" color="#9CA5AC" />
          </BreadcrumbItem>
          <BreadcrumbItem color="primary">Служба поддержки</BreadcrumbItem>
        </Breadcrumbs>
      </div>

      <div className="mt-6">
        <h1 className="hidden lg:inline text-4xl text-[#222222] font-bold">
          Служба поддержки
        </h1>
      </div>
      <p className="font-semibold text-[#222222] mt-6 lg:mt-12 lg:text-xl">
        Мы всегда готовы помочь и ответить на все ваши вопросы
      </p>

      <p className="text-sm text-[#60656C] mt-3 lg:text-base lg:mt-6">
        Свяжитесь с нами любым удобным споcобом в рабочее время с 08:00 до 00:00
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-3 lg:gap-y-6 mt-8 lg:mt-9">
        <Item
          icon={<LazyImage src={mailIcon} />}
          title="Написать на почту"
          subtitle="f.abdikadyr@zerdegroup.kz"
          onPress={() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            if (window.Launch) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-expect-error
              window.Launch.postMessage('mailto:f.abdikadyr@zerdegroup.kz');
            }
          }}
        />

        <Item
          icon={<LazyImage src={callIcon} />}
          title="Позвонить"
          subtitle="+7 (701) 777 67 70"
          onPress={() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            if (window.Launch) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-expect-error
              window.Launch.postMessage('tel:+7-701-777-67-70');
            }
          }}
        />

        <Item
          icon={<LazyImage src={whatsappIcon} />}
          title="Написать в WhatsApp"
          subtitle="+7 (701) 777 67 70"
          onPress={() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            if (window.Launch) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-expect-error
              window.Launch.postMessage(
                'https://wa.me/77017776770?text=%D0%94%D0%BE%D0%B1%D1%80%D1%8B%D0%B9%20%D0%B4%D0%B5%D0%BD%D1%8C%2C%20%D0%BF%D0%B8%D1%88%D1%83%20%D0%B2%D0%B0%D0%BC%20%D0%B8%D0%B7%20%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F%20Zerde%2024%2C%20%D0%BC%D0%BD%D0%B5%20%D0%BD%D1%83%D0%B6%D0%BD%D0%B0%20%D0%BF%D0%BE%D0%BC%D0%BE%D1%89%D1%8C%21'
              );
            }
          }}
        />

        <Item
          icon={<LazyImage src={instagramIcon} />}
          title="Мы в Instagram"
          subtitle="@zerdepharma"
          onPress={() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            if (window.Launch) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-expect-error
              window.Launch.postMessage(
                'https://www.instagram.com/zerdepharma?igsh=bnI0ZXplNnhuZ3do'
              );
            }
          }}
        />
      </div>

      <div className="hidden lg:block h-[280px]"></div>
    </div>
  );
};

// обновление
